import { marketSlice } from "./store/market.slice";
import {
  marketApi,
  useGetMarketsQuery,
  useCreateMarketMutation,
  useUpdateMarketMutation,
  useLazyGetMarketByIdQuery,
  useLazyGetMarketsQuery,
  useDeleteMarketMutation
} from "./api/market.api";

export const { setMarkets } = marketSlice.actions;

export {
  marketApi,
  marketSlice,
  useGetMarketsQuery,
  useCreateMarketMutation,
  useUpdateMarketMutation,
  useLazyGetMarketByIdQuery,
  useLazyGetMarketsQuery,
  useDeleteMarketMutation
};
